import type { FloorPlanRecord } from "components/SmartSurveyor/SmartSurveyorForRudolfFritz/hooks/types";

export const resolvePlanRecordIndex = (
  records: FloorPlanRecord[],
  idParam: number | null,
): number | null => {
  if (idParam === null) return null;
  const index = records.findIndex((record) => record.id === idParam);
  return index >= 0 ? index : null;
};

export const findFirstActivePlanIndex = (
  records: FloorPlanRecord[],
): number | null => {
  const index = records.findIndex((record) => record.archivedAt === null);
  return index >= 0 ? index : null;
};

export const findFirstArchivedPlanIndex = (
  records: FloorPlanRecord[],
): number | null => {
  const index = records.findIndex((record) => record.archivedAt !== null);
  return index >= 0 ? index : null;
};
